import { LevelDesignerComponent } from '../../level-designer/level-designer.component';
import { PropertyEditor } from '../property-editor';
import { MultipleValues } from './input-base';
import { NumberInput } from './number-input';
import { OrganizationsService } from 'src/app/Services/organizations.service';

export class DimensionInput extends NumberInput {
    constructor(
        ctx: CanvasRenderingContext2D,
        x: number,
        y: number,
        width: number,
        height: number,
        value: number,
        isActive: boolean,
        private organizationsService: OrganizationsService,
        levelDesigner: LevelDesignerComponent,
        propertyEditor: PropertyEditor
    ) {
        // Format initial value
        super(ctx, x, y, width - 50, height, value, isActive, levelDesigner, propertyEditor);
    }

    override draw(): void {
        
        super.draw();

        // Draw unit
        this.ctx.save();
        this.ctx.fillStyle = '#666666';
        this.ctx.font = '10px Arial';
        this.ctx.textAlign = 'right';
        const unit = this.organizationsService?.MeasurementSystem === 'Metric' ? 'meters' : 'feet';
        this.ctx.fillText(unit, this.x + this.width + 45, this.y + this.height / 2);
        this.ctx.restore();
    }

    override setValue(value: any): void {
        
        if(value instanceof MultipleValues) {
            this.displayValue = value.toString();
            this.value = null;
            return;
        }

        this.displayValue = parseFloat(value).toFixed(2);
        if (this.organizationsService?.MeasurementSystem === 'Imperial') {
            value *= 3.28084; // Convert feet to meters
        }
        this.value = Number(parseFloat(value).toFixed(2));
        
    }
}

// Helper function to format display values
function formatDisplayValue(value: number, organizationsService: OrganizationsService): string {
    if (isNaN(value)) return '0.00';
    
    if (organizationsService.MeasurementSystem === 'Imperial') {
        value *= 3.28084; // Convert meters to feet
    }
    return value.toFixed(2);
} 
